import { render, staticRenderFns } from "./MessageVirtualItem.vue?vue&type=template&id=256c156f&scoped=true&"
import script from "./MessageVirtualItem.vue?vue&type=script&lang=js&"
export * from "./MessageVirtualItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageVirtualItem.vue?vue&type=style&index=0&id=256c156f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c156f",
  null
  
)

export default component.exports